import styled from 'styled-components';
import theme from 'common/theme';

export const SplitListContainer = styled.dl.attrs(
  (props?: { className?: string; scrollable?: boolean }) => ({
    className: `split-list ${props?.className || ''}${props?.scrollable ? `is-scrollable` : ``}`.trim()
  })
)<{ className?: string; scrollable?: boolean } | undefined>`
  list-style: none;
  display: grid;
  grid-auto-flow: row;
  grid-template-columns: 1fr auto;
  text-transform: capitalize;
  margin: 0;
  padding: 0;
  width: 100%;

  
  overflow: ${({ scrollable }) => (scrollable ? 'auto' : undefined)};

  dd,
  dt {
    display: flex;
    margin: 0;
    border-top: solid 1px ${theme.colors.border.lightest};
    min-width: max-content;
    padding: .4em 0 .3em 0;

    &:nth-child(1),
    &:nth-child(2) {
      border: none;
    }
  }

  dt {
    width: 100%;
    align-self: start;
    padding-right: .6em;
  }
  dd {
    padding-left: .6em;
    font-weight: 800;
    justify-content: flex-end;
    color: ${theme.colors.mainLight};
  }

  &.small {
    max-width: max-content;
    dd { padding-left: 0; }
    dt { padding-right: 0; }
  }
`;
